'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('carrierProfileSectionStatus', carrierProfileSectionStatus);

	function carrierProfileSectionStatus() {
		return {
			restrict: 'E',
			scope: { 
				data: '='
			},
			replace: false,
			templateUrl: '/app/common/directives/carrierProfileSectionStatus.html',
			link: linkFunction
		};
	}
		
	function linkFunction(scope) {     
		activate();
	
		function activate() {
			scope.carrierProfileSections = [];
			scope.getCarrierProfileSectionCssClass = getCarrierProfileSectionCssClass;
			scope.getProgressMessageInfo = getProgressMessageInfo;
			scope.getCarrierProfileSectionPath = getCarrierProfileSectionPath;
			scope.$watch('data', function(value) {
				scope.completedSectionsCounter = 0;
				scope.carrierId = value.carrierId;
				scope.carrierProfileSections = createCarrierProfileSections(value.carrierProfileSectionsStatus);
			}, true);
		}

		function getCarrierProfileSectionCssClass(isComplete) {
			return isComplete ? 'complete-section': 'incomplete-section';
		}

		function calculateCompletedCarrierProfileSections(isComplete) {
			if (isComplete) {
				scope.completedSectionsCounter++;
			}
		}

		function createCarrierProfileSection(tooltipText, isComplete, path) {
			calculateCompletedCarrierProfileSections(isComplete);
			
			return { tooltipText: tooltipText, isComplete: isComplete, path: path };
		}

		function getCarrierProfileSectionPath(path) {
			return path + '?carrierId=' + scope.carrierId;
		}

		function getProgressMessageInfo() {
			var maxCompletedSections = 8;
			if (scope.completedSectionsCounter === maxCompletedSections) {
				return 'All sections completed';
			}

			return scope.completedSectionsCounter + ' of ' + maxCompletedSections + ' sections complete';
		}

		function createCarrierProfileSections(carrierProfileSectionsStatus) {
			if (!carrierProfileSectionsStatus) {
				return [];
			}

			return [
				createCarrierProfileSection('Company', carrierProfileSectionsStatus.companyInfoComplete, 'profile/company'),
				createCarrierProfileSection('Contacts', carrierProfileSectionsStatus.contactsComplete, 'profile/contacts'),
				createCarrierProfileSection('Fleet', carrierProfileSectionsStatus.equipmentInfoComplete, 'profile/fleetservices'),
				createCarrierProfileSection('Lanes', carrierProfileSectionsStatus.laneInfoComplete, 'profile/laneCoverage'),
				createCarrierProfileSection('Tax', carrierProfileSectionsStatus.taxInfoComplete, 'profile/taxes'),
				createCarrierProfileSection('Documents', carrierProfileSectionsStatus.documentsComplete, 'profile/documents'),
				createCarrierProfileSection('Insurance', carrierProfileSectionsStatus.insuranceInfoComplete, 'profile/insurance'),
				createCarrierProfileSection('Contracts', carrierProfileSectionsStatus.contractsComplete, 'profile/contracts')
			];
		}
	}
})();
